import { render, staticRenderFns } from "./BatchShopEdit.vue?vue&type=template&id=682dd545"
import script from "./BatchShopEdit.vue?vue&type=script&lang=ts"
export * from "./BatchShopEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports